import { render, staticRenderFns } from "./emptyDir.vue?vue&type=template&id=bf0793ec&"
import script from "./emptyDir.vue?vue&type=script&lang=js&"
export * from "./emptyDir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports